import { render } from "./CreatureEdit.vue?vue&type=template&id=def6a018&lang=true"
import script from "./CreatureEdit.vue?vue&type=script&lang=js"
export * from "./CreatureEdit.vue?vue&type=script&lang=js"
script.render = render

export default script